import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import { SETTINGS_RESOURCES, SETTINGS_SCOPES, PAGE_NAMES } from 'constant';
import AuthorizedRoute from 'routes/AuthorizedRoute';

import EditUser from './submodules/edit';
import ListUser from './submodules/list';
import CreateUser from './submodules/create';

const UserManagementDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={SETTINGS_RESOURCES.user}
				actions={[SETTINGS_SCOPES[SETTINGS_RESOURCES.user].listUsers]}
				configPageName={PAGE_NAMES.settings}
				exact
				path={`${path}/list`}
				component={ListUser}
			/>
			<AuthorizedRoute
				entity={SETTINGS_RESOURCES.user}
				actions={[SETTINGS_SCOPES[SETTINGS_RESOURCES.user].listUsers]}
				configPageName={PAGE_NAMES.settings}
				exact
				path={`${path}/create`}
				component={CreateUser}
			/>
			<AuthorizedRoute
				entity={SETTINGS_RESOURCES.user}
				actions={[SETTINGS_SCOPES[SETTINGS_RESOURCES.user].createUser]}
				configPageName={PAGE_NAMES.settings}
				exact
				path={`${path}/edit`}
				component={EditUser}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default UserManagementDashboard;
